const twitter = 'https://twitter.com/playefas'
const facebook = 'https://www.facebook.com/EarthFromAnotherSun'
const linkedin = 'https://linkedin.com/company/multiverse-entertainment'
const instagram = 'https://www.instagram.com/earthfromanothersun'
const youtube = 'https://www.youtube.com/channel/UCVKC_lmS0sMRndeS8gdoVTw'
// const lang = [
//   { id: "en", name: "English"},
//   { id: "zh", name: "中文"},
// ]
const languages = {
  en: "English",
  zh: "中文",
}
export default {
  facebook,
  twitter,
  linkedin,
  instagram,
  youtube,
  languages,
}